module.exports = __webpack_public_path__ + "static/beneficios-c5ae91fe93e08f89ef7ef28be9bac89d.png";